import _uniqueId from "lodash/uniqueId";
import * as React from 'react';
import KeyCodes from "../lib/KeyCodes";
import ScrollableMenu, { outOfBounds, moveUp, moveDown } from "../ScrollableMenu";
import { Text } from "../Text";
class SearchableList extends React.Component {
  constructor(props) {
    super(props);
    this.input = void 0;
    this.resultsID = void 0;
    this.handleKeyDown = e => {
      const {
        keyCode
      } = e;
      const {
        highlightedIndex,
        results
      } = this.props;
      switch (keyCode) {
        case KeyCodes.RETURN:
          e.preventDefault();
          if (results.length && !outOfBounds(results.length, highlightedIndex)) {
            this.handleSelect(highlightedIndex);
          }
          return;
        case KeyCodes.UP:
          e.preventDefault();
          this.handleHighlight(moveUp(results.length, highlightedIndex));
          return;
        case KeyCodes.DOWN:
          e.preventDefault();
          this.handleHighlight(moveDown(results.length, highlightedIndex));
          return;
        default:
          if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
          }
      }
    };
    this.handleHighlight = highlightedIndex => {
      this.props.onHighlight(highlightedIndex);
    };
    this.handleQueryChange = e => {
      const {
        target
      } = e;
      if (target instanceof HTMLInputElement) {
        const {
          value
        } = target;
        this.props.onChangeQuery(value);
      }
    };
    this.handleSelect = selectedIndex => {
      const entry = this.props.results[selectedIndex];
      this.props.onSelect(entry);
    };
    this.inputRef = node => {
      this.input = node;
    };
    this.renderEmpty = () => {
      const {
        queryString,
        renderError,
        renderEmpty,
        status
      } = this.props;
      if (status === 'error') {
        return renderError({
          queryString
        });
      } else if (status === 'loading') {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return renderEmpty({
        queryString
      });
    };
    this.renderError = () => {
      const {
        queryString
      } = this.props;
      return this.props.renderError({
        queryString
      });
    };
    this.resultsID = `searchable-list-results-${_uniqueId()}`;
  }
  focus() {
    if (this.input) {
      this.input.focus();
    }
  }
  render() {
    const {
      highlightedIndex,
      inputPlaceholder,
      maxHeight,
      minHeight,
      queryString,
      renderInput,
      renderAccessibleStatusMessage,
      results,
      status,
      renderItem,
      renderFooter
    } = this.props;
    const activeDescendant = highlightedIndex >= 0 ? `${this.resultsID}-item-${highlightedIndex}` : '';
    const style = {
      maxHeight: `${maxHeight}px`
    };
    if (minHeight) {
      style.minHeight = `${minHeight}px`;
    }
    return /*#__PURE__*/React.createElement("div", null, renderInput({
      ariaActiveDescendant: activeDescendant,
      ariaOwns: this.resultsID,
      open: true,
      onChange: this.handleQueryChange,
      onKeyDown: this.handleKeyDown,
      placeholder: inputPlaceholder,
      // @ts-expect-error - TS2345 - Argument of type '{ ariaActiveDescendant: string; ariaOwns: string; open: true; onChange: (e: React.ChangeEvent<HTMLInputElement>) => void; onKeyDown: (e: React.KeyboardEvent<Element>) => void; ... 4 more ...; value: string; }' is not assignable to parameter of type 'SearchableListInputProps<T>'.
      ref: this.inputRef,
      results,
      status,
      value: queryString || ''
    }), !!results && status !== 'loading' && status !== 'error' ? /*#__PURE__*/React.createElement(Text, {
      visuallyHidden: true,
      role: "status",
      "aria-live": "polite"
    }, renderAccessibleStatusMessage(results)) : null, /*#__PURE__*/React.createElement(ScrollableMenu, {
      className: "SearchableList-items",
      highlightedIndex: highlightedIndex,
      id: this.resultsID,
      onHighlight: this.handleHighlight,
      onSelect: this.handleSelect,
      entries: results,
      renderEmpty: this.renderEmpty,
      renderItem: renderItem,
      renderFooter: renderFooter,
      style: style
    }));
  }
}
// @ts-expect-error - TS2302 - Static members cannot reference class type parameters.
SearchableList.defaultProps = {
  maxHeight: 200,
  renderEmpty: () => /*#__PURE__*/React.createElement("div", null),
  // @ts-expect-error - TS2322 - Type '(results: readonly T[]) => string' is not assignable to type '(props: readonly T[]) => ReactElement<any, string | JSXElementConstructor<any>>'.
  renderAccessibleStatusMessage: results => {
    if (!results.length) {
      return 'No results found';
    }
    if (results.length === 1) {
      return '1 result found';
    }
    return `${results.length} results found`;
  }
};
export default SearchableList;